import { Component } from '@angular/core'

import { MDBaseButtonComponent } from './base-button.component'

@Component({
  selector: 'add-btn',
  templateUrl: 'add-btn.component.html',
})
export class MDAddButtonComponent extends MDBaseButtonComponent {}
